// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vfjf3","index":"styles_index__5KVSs"};